module.exports = __webpack_public_path__ + "static/houses_night-8e2b5f7cbf67c9d18441b9d40512735e.jpg";